var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6666 14.1667H3.33325C2.87301 14.1667 2.49992 14.5398 2.49992 15C2.49992 15.4602 2.87301 15.8333 3.33325 15.8333H16.6666C17.1268 15.8333 17.4999 15.4602 17.4999 15C17.4999 14.5398 17.1268 14.1667 16.6666 14.1667ZM3.33325 12.5C1.95254 12.5 0.833252 13.6193 0.833252 15C0.833252 16.3807 1.95254 17.5 3.33325 17.5H16.6666C18.0473 17.5 19.1666 16.3807 19.1666 15C19.1666 13.6193 18.0473 12.5 16.6666 12.5H3.33325Z",
    fill: "#777E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 3.33333C10.8334 2.8731 10.4603 2.5 10.0001 2.5C9.53984 2.5 9.16675 2.8731 9.16675 3.33333V7.98816L8.08934 6.91074C7.7639 6.58531 7.23626 6.58531 6.91083 6.91074C6.58539 7.23618 6.58539 7.76382 6.91083 8.08926L9.41083 10.5893C9.73626 10.9147 10.2639 10.9147 10.5893 10.5893L13.0893 8.08926C13.4148 7.76382 13.4148 7.23618 13.0893 6.91074C12.7639 6.58531 12.2363 6.58531 11.9108 6.91074L10.8334 7.98816V3.33333Z",
    fill: "#777E91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.e3d584af314ed511857d9cc144326f0c.svg";
export { ForwardRef as ReactComponent };